<template>
  <div>
    <b-alert :show="errors.any()" variant="danger" class="mb-2 py-2 px-4">
      <ul class="m-0 px-1">
        <li v-for="err in errors.all()" :key="err">{{err}}</li>
      </ul>
    </b-alert>

    <widget
      :type="widget.type"
      :title="widget.title"
      :subtitle="widget.subtitle"
      :url="widget.url"
      :availability="widget.availability"
      :viewData="widget.viewData"
      :view="widget.view"
      @update:type="widget.type = $event"
      @update:title="widget.title = $event"
      @update:subtitle="widget.subtitle = $event"
      @update:url="widget.url = $event"
      @update:availability="widget.availability = $event"
      @update:viewData="widget.viewData = $event"
      @update:view="widget.view = $event"
    >
      <b-row class="align-items-center">
        <b-col md="6" xl="3" class="mb-2 mb-xl-0">
          <b-btn class="form-control input-button" @click="showModal">
            {{ $t('widgetAreas.advanceSettings') }}
          </b-btn>
        </b-col>

        <b-col md="6" xl="3" class="mb-2 mb-xl-0">
          <b-input-group :prepend="$t('widgetAreas.count')">
            <numeric-input v-model="widget.count"/>
          </b-input-group>
        </b-col>

        <b-col md="6" xl="3">
          <c-switch v-model="widget.featuredOnly" variant="3d" color="success" :text="$t('widgetAreas.featuredOnly')"/>
        </b-col>

        <b-col md="6" xl="3">
          <c-switch v-model="widget.availableOnly" variant="3d" color="success" :text="$t('widgetAreas.availableProductsOnly')"/>
        </b-col>
      </b-row>
    </widget>

    <advance-settings ref="modal" v-model="widget"/>
  </div>
</template>

<script>
import EditorMixin from '../EditorMixin'
import AdvanceSettings from './AdvanceSettings'
import Widget from '../../Widget'
import cSwitch from '@/components/shared/Switch'

export default {
  name: 'ProductsWidget',
  mixins: [EditorMixin],
  components: {
    AdvanceSettings,
    cSwitch,
    Widget
  },
  methods: {
    showModal () {
      this.$refs.modal.show()
    }
  }
}
</script>
